<template>
	<div ref="chart" style="width: 250px; height: 50px"></div>
</template>

<script>
import * as echarts from "echarts";

// chart inspired by https://echarts.apache.org/examples/en/editor.html?c=custom-error-bar
// and https://stackoverflow.com/questions/61057892/is-there-a-way-to-add-error-bar-to-echarts-library

export default {
	props: {
		categoryData: {
			type: Array,
			required: true,
		},
		data: {
			type: Object,
			required: true,
		},
		chartInterval: {
			type: Array,
			required: true,
		},
	},
	computed: {
		errorData() {
			return [[0, this.data.min, this.data.max]];
		},
		barData() {
			return [echarts.number.round(parseInt(this.data.mean))];
		},
	},
	data() {
		return {
			myChart: null,
		};
	},
	mounted() {
		let chartDom = this.$refs.chart,
			option = {
				xAxis: {
					type: "value",
					min: this.chartInterval[0],
					max: this.chartInterval[1],
					axisLine: {
						show: false,
						lineStyle: {
							color: "#DFDFDE",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							color: "#EBEBEA",
						},
					},
				},
				yAxis: {
					data: this.categoryData,
					type: "category",
					axisLabel: {
						show: false,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: "#C9C9C7",
							//color: '#ffffff'
						},
					},
				},
				series: [
					{
						type: "scatter",
						data: this.barData,
						itemStyle: {
							color: "#F19300",
						},
						// label: {
						//     position: 'top',
						//     show: true,
						//     formatter: '⌀ {c} €/t'
						// },
						silent: true,
					},
					{
						type: "custom",
						name: "error",
						itemStyle: {
							borderWidth: 1.5,
						},
						renderItem: function (params, api) {
							var yValue = api.value(0);
							var highPoint = api.coord([api.value(1), yValue]);
							var lowPoint = api.coord([api.value(2), yValue]);
							var halfWidth = 7;
							var style = api.style({
								stroke: "#F19300",
								fill: undefined,
							});
							return {
								type: "group",
								children: [
									{
										type: "line",
										transition: ["shape"],
										shape: {
											x1: highPoint[0],
											y1: highPoint[1] - halfWidth,
											x2: highPoint[0],
											y2: highPoint[1] + halfWidth,
										},
										style: style,
									},
									{
										type: "line",
										transition: ["shape"],
										shape: {
											x1: lowPoint[0],
											y1: lowPoint[1] - halfWidth,
											x2: lowPoint[0],
											y2: lowPoint[1] + halfWidth,
										},
										style: style,
									},
									{
										type: "line",
										transition: ["shape"],
										shape: {
											x1: highPoint[0],
											y1: highPoint[1],
											x2: lowPoint[0],
											y2: lowPoint[1],
										},
										style: style,
									},
								],
							};
						},
						encode: {
							x: 0,
							y: [1, 2],
						},
						data: this.errorData,
						z: 100,
						label: {
							show: false, //(this.data.min != this.data.max),
							// position: 'left',
							// color: '#454545',
							// formatter: function (d) {
							//     return d.data[1] + " €/t";
							// }
						},
						silent: true,
					},
				],
				textStyle: {
					fontFamily: "Barlow, Roboto, Helvetica, Arial, sans-serif",
					fontSize: "14",
					fontWeight: "500",
				},
				grid: {
					containLabel: false,
					left: "1px",
					right: "0",
					top: "0px",
					bottom: "0px",
				},
			};

		this.myChart = echarts.init(chartDom);
		this.myChart.setOption(option);
	},
};
</script>
